export default __webpack_public_path__ + "static/media/contact-us.9ede0514.md";